var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMorning = function SvgMorning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "morning_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#morning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M11.501 5.424V2.039h1v3.385zm5.496 2.288-.707-.727 2.402-2.407.707.732zm1.581 4.789v-1h3.385v1zm.114 6.898-2.402-2.402.727-.727 2.407 2.396zM7.024 7.73l-2.44-2.44.733-.694 2.415 2.427zm-.446 11.385h4.116q.817 0 1.408-.591.591-.592.591-1.409t-.569-1.399a1.87 1.87 0 0 0-1.386-.582H9.77l-.365-.873A3.13 3.13 0 0 0 8.2 12.834a3.3 3.3 0 0 0-1.813-.526q-1.384 0-2.346.962-.962.96-.962 2.346 0 1.461 1.02 2.48 1.019 1.02 2.48 1.02m0 1q-1.863 0-3.182-1.318-1.318-1.32-1.318-3.182 0-1.806 1.251-3.057t3.057-1.25q1.365 0 2.478.773a4.2 4.2 0 0 1 1.578 2.053q1.257 0 2.245.758.987.757 1.007 2.238a2.93 2.93 0 0 1-.88 2.109q-.87.876-2.12.876zm7.077-3.37q-.068-.249-.135-.484l-.134-.485a4.3 4.3 0 0 0 1.899-1.503Q16 13.264 16 12q0-1.65-1.175-2.825T12.001 8A3.88 3.88 0 0 0 9.3 9.043q-1.144 1.043-1.267 2.6a19 19 0 0 0-.506-.129 20 20 0 0 1-.506-.129q.235-1.891 1.66-3.138A4.9 4.9 0 0 1 12 7q2.077 0 3.539 1.461Q17 9.924 17 12.001a4.86 4.86 0 0 1-.917 2.885 5.16 5.16 0 0 1-2.429 1.86"
  }))));
};
export default SvgMorning;